import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import { useHistory } from 'react-router-dom';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import styled from 'styled-components/macro';
import Modal from 'components/Modal';

const RejectedDoc = styled.div`
  margin: 5px 0px;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  letter-spacing: -0.5px;
  line-height: 19px;
`;

const RebatchDocument = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const history = useHistory();
  const docIds = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const documentsList = useSelector(selectors.documents.selectAllActiveDocuments);
  const [errorProtocols, setErrorProtocols] = useState<number[]>([]);
  const [visbility, setErrorModal] = useState(false);
  const listOfDocumentsRejected = documentsList.filter((doc) => doc.workflowStatus === 3);
  const [ErrorModal] = utils.hooks.useBulkActionErrorModal(errorProtocols, visbility);

  const onConfirm = async () => {
    try {
      const { data } = await services.rebatchDocument(docIds, !!listOfDocumentsRejected.length);
      let protocolArrToBeMoved = [...docIds];
      if (!data.success) {
        const protocolsError = data.protocols;
        setErrorProtocols(protocolsError);
        setErrorModal(true);
        utils.app.notify('warning', t('rebatch-warning'));
        protocolArrToBeMoved = protocolArrToBeMoved.filter((protocol) => !protocolsError.includes(protocol));
      } else {
        dispatch(actions.modal.closeModal());
        utils.app.notify('success', t('success-rebatch'));
        dispatch(actions.documents.removeRows(protocolArrToBeMoved));
        if (utils.documents.isOpenDocumentView()) dispatch(actions.documents.openNextDocument(history));
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {visbility ? (
        <ErrorModal />
      ) : (
        <>
          <Modal.Header
            title={t('rebatch-title')}
            subtitle={t('rebatch-subtitle')}
            noMargin={listOfDocumentsRejected.length === 0}
          />
          {listOfDocumentsRejected.length > 0 && (
            <Modal.Content>
              <RejectedDoc>{t('list-of-rejected-docs')} </RejectedDoc>
              {listOfDocumentsRejected.map((doc) => (
                <RejectedDoc key={doc.protocol}>{doc.protocol}</RejectedDoc>
              ))}
            </Modal.Content>
          )}
          <Modal.Footer confirmText={t('continua')} confirmAction={onConfirm} closeButtonText={t('annulla')} />
        </>
      )}
    </>
  );
};

export default RebatchDocument;
